import {EyeIcon, EyeSlashIcon} from '@heroicons/react/24/outline'
import React, {ComponentProps} from 'react'

type MaskButtonProperties = Readonly<{
  masked: boolean
}> &
  Omit<ComponentProps<'button'>, 'aria-hidden' | 'className' | 'type'>

/**
 * A {@link button} to show and hide masked {@link TextInput}s.
 *
 * @param masked A boolean specifying if the {@link TextInput} value is currently masked.
 * @param buttonProps {@link button} properties.
 */
function MaskButton({masked = true, ...buttonProps}: MaskButtonProperties) {
  return (
    <button
      {...buttonProps}
      aria-hidden
      className="inline-block text-navy outline-none focus-visible:rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy"
      type="button"
    >
      {masked && <EyeSlashIcon aria-hidden className="h-6 w-6" />}
      {!masked && <EyeIcon aria-hidden className="h-6 w-6" />}
    </button>
  )
}

export default MaskButton
